var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sold-out main-container"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/course/xiajia@2x.png")}}),_c('div',{staticClass:"tip"},[_c('span',[_vm._v("啊哦，你来晚了，该"+_vm._s(_vm.name)+"不存在或者已下架～")]),_c('a',{on:{"click":_vm.goToList}},[_vm._v("看看其他"+_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }